<template>
  <div>
    <ListLayout
      :title="`${subscriptionModule.subscription}`"
      :tableData="subscriptionList"
      :tableHeader="tableHeaders"
      :total="totalItems"
      @getList="getSubscriptionList"
      :context="context"
    >
      <template #listAction>
        <!-- <v-btn
            @click="$router.push({ path: '/app/admin/subscription/add' })"
            color="primary"
            class="white--text"
            depressed
          >
            <v-icon>mdi-plus</v-icon>
            <span class="text-body-2">Add Subscription</span>
          </v-btn> -->
      </template>
      <template #dialogs>
        <SubscriptionDetails
          :subscriptionDetailID="subscriptionDetailID"
          v-model="showSubscriptionDetailsForm"
        />
      </template>
    </ListLayout>
  </div>
</template>
  
  <script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import SubscriptionButton from "@/components/Button/SubscriptionButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import SubscriptionStatus from "@/components/ModuleBasedComponents/Subscription/SubscriptionStatus.vue";
import SubscriptionTrialStatus from "@/components/ModuleBasedComponents/Subscription/SubscriptionTrialStatus.vue";
import { getUserDetailsLocalStorage } from "@/utils/functions";
import SubscriptionDetails from "@/components/ModuleBasedComponents/Subscription/SubscriptionDetails.vue";
import { subscriptionModule } from "@/utils/moduleMapping";

export default {
  components: {
    SubscriptionButton,
    ListLayout,
    SubscriptionStatus,
    SubscriptionTrialStatus,
    SubscriptionDetails,
  },
  data() {
    return {
      subscriptionModule,
      sorting: {},
      itemsPerPage: 10,
      pageNo: 1,
      totalItems: 0,
      filters: {},
      subscriptionList: [],
      systemAdminHeaders: [
        {
          headerName: "Subscription Name",
          field: "name",
          sortable: true,
          pinned: "left",
        },
        {
          headerName: "Days",
          field: "days",
          sortable: true,
          pinned: "left",
        },
        {
          headerName: "Trial",
          field: "is_trial",
          sortable: true,
          cellClass: "text-capitalize",
          cellRenderer: "SubscriptionTrialStatus",
        },

        {
          headerName: "Status",
          field: "is_active",
          sortable: true,
          cellClass: "text-capitalize",
          cellRenderer: "SubscriptionStatus",
        },
      ],
      headerSelected: [
        {
          headerName: "Subscription Name",
          field: "name",
          sortable: true,
          pinned: "left",
        },
        {
          headerName: "Days",
          field: "days",
          sortable: true,
        },
        {
          headerName: "Trial",
          field: "is_trial",
          sortable: true,
          cellClass: "text-capitalize",
          cellRenderer: "SubscriptionTrialStatus",
        },
        {
          headerName: "Status",
          field: "is_active",
          sortable: true,
          cellClass: "text-capitalize",
          cellRenderer: "SubscriptionStatus",
        },
      ],

      isEditing: false,

      showSubscriptionForm: false,
      selectedSubscriptionID: null,

      showSubscriptionDetailsForm: false,
      subscriptionDetailID: null,
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
    tableHeaders() {
      let userObj = getUserDetailsLocalStorage();
      return [
        ...(userObj.role == "system_admin"
          ? this.systemAdminHeaders
          : this.headerSelected),
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 100,
          sortable: false,
          width: 100,
          cellRenderer: "SubscriptionButton",
        },
      ];
    },
  },
  methods: {
    getSubscriptionList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.filters,
      };

      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }

      this.$api.subscription
        .getSubscriptionList(params)
        .then((res) => {
          this.subscriptionList = res.data;
          this.totalItems = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    viewSubscriptionDetails(id) {
      this.subscriptionDetailID = id;
      this.showSubscriptionDetailsForm = true;
    },
  },
};
</script>
  